module.exports = __webpack_public_path__ + "static/media/amateur.45aed8a4.png";